import { CircleCheck, Ban } from "lucide-react";
import React from "react";
import moment from "moment";
import { InboxQueryDetails, InboxQueryStatus } from "../utils/types";

interface QueryDetailsHistoryProps {
  ticket: InboxQueryDetails;
}
const QueryDetailsHistory: React.FC<QueryDetailsHistoryProps> = ({
  ticket,
}): JSX.Element => {
  const ticketHistory = ticket.history ?? [];

  const renderHistoryIcon = (action: string): JSX.Element => {
    switch (action) {
      case InboxQueryStatus.DECLINED:
        return <Ban size={24} className="text-jem-primary-base" />;
      case InboxQueryStatus.APPROVED:
        return <CircleCheck size={24} className="text-jem-primary-base" />;
      default:
        return <CircleCheck size={24} className="text-jem-primary-base" />;
    }
  };

  return (
    <div className="flex flex-col gap-6 pb-6 font-roboto">
      {ticketHistory.map((history) => (
        <div className="flex flex-col" key={history.timestamp}>
          <div className="flex justify-between items-center gap-4">
            {/* Header // Resolution action */}
            <h3 className="flex flex-row items-center font-bold text-jem-primary-base text-lg mt-[1px] capitalize">
              {renderHistoryIcon(history.action)}
              <span className="ml-4">{history.action.toLowerCase()}</span>
            </h3>
            <span className="text-jem-primary-50t text-xs">
              {history.actioned_by.first_name} {history.actioned_by.last_name} •{" "}
              {moment(history.timestamp).format("D MMMM YYYY [at] HH:mm")}
            </span>
          </div>
          <div className="flex flex-col gap-6">
            {/* Resolution reason / query outcome */}
            {history.outcome && (
              <div className="flex flex-col gap-2 pl-10 pt-4">
                <span className="text-jem-primary-50t text-xs -mb-2">
                  Reason
                </span>
                <span className="text-[16px] text-jem-primary-base">
                  {history.outcome}
                </span>
              </div>
            )}
            {/* Employee message */}
            {history.message && (
              <div className="flex flex-col gap-2 pl-10">
                <span className="text-jem-primary-50t text-xs -mb-2">
                  Message to employee
                </span>
                <span className="text-[16px] text-jem-primary-base">
                  {history.message}
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export default QueryDetailsHistory;
